import React from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import Header from './Header';

class Dummy extends React.Component {

}

export default Dummy;


// WEBPACK FOOTER //
// ./src/dummy.js